<template>
    <div class="sidebar-icon">
        <promotion-copy-dialog
            :key="`copyPromotionDialog::${promotion._id}`"
            :promotions="[promotion]"
        />

        <v-tooltip
            v-if="promotion.parentPromotionId"
            location="top"
            :disabled="!isActionsDisabled"
            :text="actionsDisabledReason"
        >
            <template v-slot:activator="{ props }">
                <span v-bind="props">
                    <child-promotion-ghost-dialog
                        :key="`childPromotionDeclineDialog::${promotion._id}`"
                        :promotion-id="promotion._id"
                        :is-ghost="promotion.isGhost"
                        :ignore-parent-read-only="true"
                        :is-ghost-disabled="isActionsDisabled"
                    />
                </span>
            </template>
        </v-tooltip>

        <v-tooltip
            v-else
            location="top"
            :disabled="!isActionsDisabled"
            :text="actionsDisabledReason"
        >
            <template v-slot:activator="{ props }">
                <span v-bind="props">
                    <common-delete-dialog
                        :disabled="isActionsDisabled"
                        :resource="promotionsEnum"
                        :resource-id="promotion._id"
                        :children="promotion.children"
                        :has-been-approved="hasBeenApproved(promotion)"
                        :child-dependencies-warning="false"
                        :ignore-parent-read-only="true"
                    />
                </span>
            </template>
        </v-tooltip>

        <main-expand-button :is-expanded="isExpanded" size="small" />
    </div>
</template>

<script>
import { find, get, isEmpty } from 'lodash';
import resources from '@enums/resources';
import workflowStates from '@enums/workflow-states';
import workflowEntities from '@enums/workflow-entities';
import promotionUtils from '@sharedModules/promotion-utils';
import lockedReasons from '@enums/locked-reasons';

export default {
    props: {
        isExpanded: {
            required: true,
            type: Boolean,
        },
        promotion: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            promotionsEnum: resources.promotions,
        };
    },
    computed: {
        isPastPromotion() {
            return (
                !!this.promotion &&
                promotionUtils.isPromotionPastEndDate({
                    moment: this.$moment,
                    endDate: this.promotion.endDate,
                })
            );
        },
        isActionsDisabled() {
            return this.isPastPromotion;
        },
        actionsDisabledReason() {
            if (this.isPastPromotion) {
                return this.toSentenceCase(this.$t(lockedReasons.promotionPastEndDate));
            }
            return this.propagatedReadOnlyReason ? this.$t(this.propagatedReadOnlyReason) : null;
        },
    },
    methods: {
        hasBeenApproved(promotion) {
            return !isEmpty(
                find(get(promotion, ['workflowState'], []), {
                    state: workflowStates.hasBeenApproved,
                    entity: workflowEntities.promotion,
                    value: true,
                })
            );
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar-icon {
    display: flex;
    gap: 0.2rem;
}
</style>
